export default "__VITE_ASSET__BTm_c1rL__"